module.exports = __webpack_public_path__ + "img/room-3.20b6f8b1.jpg";